import { useQuery } from "react-query";
import { getScorecardGeneralGroup } from "../../../../actions/CarrierAgreementMgmt/ScoreCard";


export const useScorecardGeneralGroup = () => {
    const { data, isLoading, refetch } = useQuery(
        "GetScorecardGeneralGroup",
        getScorecardGeneralGroup,
        {
            refetchOnWindowFocus: false,
        }
    );

    return { data, isLoading, refetch };
};